/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import queryString from "query-string"
import { useEffect, useRef, useState } from "react"
import { InputDate } from "@grapecity/wijmo.input"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import dayjs from "dayjs"
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { showInfoToast } from "../../../components/CustomToast"
import { useDispatch } from "react-redux"
import { useHistory, useLocation, useParams } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { clearAlert, setWarningAlerts } from "../../../globalStore/alertStore"
import { TWijmoCellTemplateContext } from "../../../type/wijmoComponents"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import KyoriWarimasiTarihuService from "../../../service/billing/kyoriWarimasiTarihu/kyoriWarimasiTarihuService"
import {
  TKyoriWarimasiTarihuGetListReq,
  TKyoriWarimasiTarihuList,
} from "../../../service/billing/kyoriWarimasiTarihu/TKyoriWarimasiTarihu"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"

import ConfirmModal from "../../../components/Modal/ConfirmModal"
import TextInput from "../../../components/InputWrapper/TextInput"
import NinusiSearchModal from "../../../components/SearchModal/NinusiSearchModal"
import NinusiService from "../../../service/master/ninusi/ninusiService"

//#region dummy
export const 荷主ダミー = [
  { 荷主名: "アーステック株式会社", 荷主コード: "100001" },
  { 荷主名: "大陽日酸（水素）", 荷主コード: "100002" },
]

//#endregion

/**
 * 距離割増運賃タリフ一覧
 * @returns
 */
const KyoriWarimasiTarihuRegister = () => {
  const history = useHistory()
  const location = useLocation()
  const { id: paramId } = useParams<{ id: string }>()
  const id = paramId ? parseInt(paramId) : undefined

  // ref
  const ref明細フォーマットフラグ = useRef<boolean>(false)

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "KyoriWarimasiTarihuRegister_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<TKyoriWarimasiTarihuList>,
    pageSize: number
  ) => {
    return new wjCore.CollectionView(data, {
      pageSize,

      calculatedFields: {},

      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })
  }

  // 検索前処理
  const beforeSearch = () => {
    // TODO:バリデーションチェック
    if (!isValidationCheckBeforeSearch()) return
    search()
  }

  /**
   * 検索時のチェック
   */
  const isValidationCheckBeforeSearch = () => {
    dispatch(clearAlert())
    Form外エラーメッセージList.splice(0, Form外エラーメッセージList.length)

    let hasError = false
    let messages: Array<string> = []

    // nullチェック
    // 荷主情報はモーダル画面で設定させるので、コードのみ判定
    if (荷主コード == null) {
      messages.push(`荷主情報 を入力してください。`)
      hasError = true
    }

    // error判定とメッセージセット
    if (hasError) {
      Form外エラーメッセージList.push(...messages)
      setHasSearched(hasError)
    }
    return !hasError
  }

  /**
   * IDがある場合の荷主検索
   */
  const loadNinusiSearch = async () => {
    try {
      const res = await new NinusiService().getList({
        荷主ID: id,
      })
      set荷主ID(res.data[0].荷主ID)
      set荷主コード(res.data[0].荷主コード)
      set荷主名(res.data[0].荷主名)
    } catch (error) {
      throw error
    }
  }

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TKyoriWarimasiTarihuGetListReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に
    setIsSubmitButton(false)

    let currentSearchCondition: TKyoriWarimasiTarihuGetListReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new KyoriWarimasiTarihuService().getList(
        currentSearchCondition
      )
      // formatItemを入れなおすためフラグを切り替え
      ref明細フォーマットフラグ.current = false

      // 検索結果をstateにセット
      set荷主ID(res.data.荷主ID)
      set更新日時(res.data.更新日時)
      setModifyToken(res.data.modifyToken)

      // 正常に検索した場合に検索完了フラグ制御
      flexGrid!.isReadOnly = false
      // uniqueな荷主の明細を取得
      setGridData({
        data: createCollectionView(res.data.距離割増タリフ明細, pageSize),
      })
      setAccordionController(false)
    } catch (error) {
      // dispatch(setAlerts(error))
      dispatch(setWarningAlerts(["エラー表示"]))
      if (flexGrid) {
        flexGrid.isReadOnly = true
      }
    } finally {
      setIsSearching(false) // 検索中状態に遷移
      setIsSubmitButton(true)
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TKyoriWarimasiTarihuGetListReq = queryString.parse(
      location.search
    )
    set荷主ID(query.荷主ID)
    set荷主コード(query.荷主コード)
    set荷主名(query.荷主名)
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TKyoriWarimasiTarihuGetListReq => {
    return {
      荷主ID,
      荷主コード,
      荷主名,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TKyoriWarimasiTarihuGetListReq
  ) => {
    return {
      荷主コード: wjCore.isNullOrWhiteSpace(searchCondition.荷主コード ?? "")
        ? ""
        : searchCondition.荷主コード,
      荷主名: wjCore.isNullOrWhiteSpace(searchCondition.荷主名 ?? "")
        ? ""
        : searchCondition.荷主名,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
    // AlertClear
    dispatch(clearAlert())
  }

  const clearSearchState = () => {
    if (!id) {
      set荷主コード("")
      set荷主名("")
    }
    setIsSubmitButton(false)

    ref明細フォーマットフラグ.current = false
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    // ヘッダーに行追加
    // header行に一行追加
    // 追加行のみ初期化時に設定
    var extraRow = new wjcGrid.Row()
    extraRow.allowMerging = true
    var columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)

    columnHeaders.columns.forEach((c, index) => {
      // 固定部分
      if (c.binding?.includes("単価")) {
        columnHeaders.setCellData(0, index, "単価")
        // ヘッダのみAlignを調整する
        grid.itemFormatter = (panel, r, c, cell) => {
          if (panel.cellType === wjcGrid.CellType.ColumnHeader) {
            cell.style.textAlign = "left"
          }
        }
      } else {
        const setHeaderText = c.header ?? ""
        columnHeaders.setCellData(0, index, setHeaderText)
      }
      c.allowMerging = true
    })

    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    // ループをフラグで制御？
    if (ref明細フォーマットフラグ.current) return

    // AddNew行を除いてデータ行がある場合に登録ボタン制御
    if (f.rows.length > 1) {
      setIsSubmitButton(true)
    } else {
      setIsSubmitButton(false)
    }

    if (e.panel === f.cells) {
      const cellBinding = e.getColumn().binding
      if (cellBinding !== null && e.getRow().dataIndex !== -1) {
        //削除済フラグの行はreadonly
        if (e.getRow().dataItem.削除フラグ) {
          wjCore.toggleClass(e.cell, "read-only-cell", true)
          return
        }
      }
    }
    // フォーマットのループ制御
    // ref明細フォーマットフラグ.current = true
  }

  const beforeSubmit = () => {
    // TODO:バリデーションチェック

    setIsConfirmModalShow(true)
  }

  // TODO:PUTのみ？
  const submit = async () => {
    showInfoToast(`submitてすと`)
    setIsConfirmModalShow(false)
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // modal
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)
  // 荷主検索用
  const [is荷主検索Modal, setIs荷主検索Modal] = useState(false)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中
  const [isSubmitButton, setIsSubmitButton] = useState(false) // 検索後

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // errorフラグ
  const [hasSearched, setHasSearched] = useState(false)
  const [Form外エラーメッセージList] = useState<string[]>([])

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]
  const [
    ,
    // 更新日時
    set更新日時,
  ] = useState<string>()
  const [
    ,
    // modifyToken
    setModifyToken,
  ] = useState<string>()

  // state
  const [荷主ID, set荷主ID] = useState<number>()
  const [荷主コード, set荷主コード] = useState<string>()
  const [荷主名, set荷主名] = useState<string>()

  //#endregion

  //#region [effect]

  useEffect(() => {
    document.title = `距離割増運賃タリフ登録`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
        // 編集で遷移してきた場合、荷主を検索
      } else if (id) {
        loadNinusiSearch().finally(() => {
          dispatch(画面ロック解除())
        })
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized])

  // error監視
  useEffect(() => {
    if (hasSearched && [...Form外エラーメッセージList].find((e) => e !== "")) {
      dispatch(setWarningAlerts([...Form外エラーメッセージList]))
    }
    setHasSearched(false)
  }, [hasSearched])

  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">距離割増運賃タリフ登録</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-80rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    {/* 固定項目 */}
                    <Row>
                      <Col>
                        <ul className="list-cmn">
                          <li className="list-cmn d-flex">
                            <div className="d-flex">
                              <TextInput
                                style={{ width: "7rem" }}
                                id="荷主コード"
                                name="荷主コード"
                                value={荷主コード}
                                setValue={() => {}}
                                isReadOnly
                                isRequired
                                maxLength={6}
                                placeholder="荷主コード"
                              />
                              {!id && (
                                <button
                                  type="button"
                                  className="icon-button"
                                  style={{
                                    minWidth: "1rem",
                                  }}
                                  onClick={() => {
                                    setIs荷主検索Modal(true)
                                  }}>
                                  <FontAwesomeIcon
                                    className="icon-button-inner"
                                    icon={faSearch}
                                  />
                                </button>
                              )}
                              <TextInput
                                style={{ width: "25rem" }}
                                id="荷主名"
                                name="荷主名"
                                value={荷主名}
                                setValue={() => {}}
                                isReadOnly
                                isRequired
                                maxLength={100}
                                placeholder="荷主名"
                              />
                            </div>
                          </li>
                        </ul>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="text-end">
                        <Button
                          type="submit"
                          disabled={isSearching}
                          onClick={(e) => {
                            e.stopPropagation()
                            e.preventDefault()
                            beforeSearch()
                          }}>
                          検索
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>

              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={
                  CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT
                }
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                searchConditionClear={searchConditionClear}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                isShowGridRowPickupButton={false}
                gridProperties={{
                  newRowAtTop: true,
                  isReadOnly: true,
                  allowMerging: "ColumnHeaders",
                  allowDragging: wjcGrid.AllowDragging.None,
                }}
                headerComponent={
                  <>
                    <div>
                      <Button
                        type="button"
                        variant={isSubmitButton ? "primary" : "secondary"}
                        className="ms-4"
                        disabled={!isSubmitButton}
                        onClick={() => {
                          // TODO:登録,Validation,
                          beforeSubmit()
                        }}>
                        登録
                      </Button>
                    </div>
                  </>
                }>
                <wjrGrid.FlexGridColumn
                  binding="適用開始日"
                  header="適用開始日"
                  width={120}
                  format="d"
                  editor={new InputDate(document.createElement("div"))}>
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TKyoriWarimasiTarihuList>
                    ) => {
                      return (
                        <>
                          <span>
                            {dayjs(context.item.適用開始日).format(
                              "YYYY/MM/DD"
                            )}
                          </span>
                        </>
                      )
                    }}></wjrGrid.FlexGridCellTemplate>
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="単価距離"
                  width={90}
                  header="単価距離"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="単価積卸回数加算"
                  width={160}
                  header="単価積卸回数加算"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="単価日祝加算"
                  width={160}
                  header="単価日祝加算"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="単価時間外加算"
                  width={160}
                  header="単価時間外加算"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="備考"
                  width={260}
                  header="備考"></wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {/* 荷主検索 */}
      <NinusiSearchModal
        size="lg"
        setIsShow={setIs荷主検索Modal}
        isShow={is荷主検索Modal}
        setNinusi={(荷主請求) => {
          set荷主コード(荷主請求.荷主コード)
          set荷主名(荷主請求.荷主名)
        }}></NinusiSearchModal>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で更新しますか？
      </ConfirmModal>
    </Container>
  )
}

export default KyoriWarimasiTarihuRegister
